import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { BackToTop } from "@/components/BackToTop";

export function GlobalScrollHelpers() {
  return (
    <>
      <ScrollProgressIndicator />
      <BackToTop />
    </>
  );
}